/**
 * Trust the content as HTML.
 */
angular.module('hjApp').filter('trustAsHtml', [
    '$sce',
    function ($sce) {
        return function (html) {
            return $sce.trustAsHtml(html);
        };
    }
]);
